export type EventAccessProblem = 'notFound' | 'forbidden'

/**
 * Why an organizer screen (dashboard, edit form, entrance screen) must not be
 * shown: the event does not exist, or the viewer does not organize it. The API
 * lets any logged-in person read an event page, so the role is checked here too.
 */
export function eventAccessProblem(
  detail: { viewer: { role: string } } | undefined,
  error: unknown,
): EventAccessProblem | null {
  const status = (error as { response?: { status?: number } } | null)?.response?.status
  // 400 = not even a valid event id (ParseUUIDPipe).
  if (status === 404 || status === 400) return 'notFound'
  if (status === 403) return 'forbidden'
  if (detail && detail.viewer.role !== 'organizer') return 'forbidden'
  return null
}
